const curriculumClass = 'us-academy-curriculum';
const sliderStepsElem = document.getElementById(
  `${curriculumClass}__steps-slider`,
);

const onPageLoad = (curriculumStepsElem, stepDescElem) => {
  if (curriculumStepsElem.length > 0 && stepDescElem.length > 0) {
    curriculumStepsElem[0].classList.add('hovered');
    stepDescElem[0].classList.remove('hide');
  }
};

const toggleCurriculum = (curriculumStepElem, stepDescElem) => {
  curriculumStepElem.forEach((element, index) => {
    element.addEventListener('mouseenter', () => {
      stepDescElem.forEach(ele => ele.classList.add('hide'));
      curriculumStepElem.forEach(ele => ele.classList.remove('hovered'));
      element.classList.add('hovered');
      stepDescElem[index].classList.remove('hide');
    });
  });
};

const initialize = () => {
  if (sliderStepsElem) {
    const curriculumStepElements = sliderStepsElem.querySelectorAll(
      `.${curriculumClass}__slider-step`,
    );
    const stepDescElem = sliderStepsElem.querySelectorAll(
      `.${curriculumClass}__slider-step-desc`,
    );

    toggleCurriculum(curriculumStepElements, stepDescElem);
    onPageLoad(curriculumStepElements, stepDescElem);
  }
};

export default {
  initialize,
};
